"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4226%3A524))
 * @trackcomponent
 * @lastsynced 2023-09-21T19:11:13.910Z
 */
export const Relationships = createSVGIcon(
  <>
    <path
      d="M13.7093 15.4018H13.913C13.913 15.4018 17.2159 15.4085 17.2608 15.4018L19.3461 15.0192C19.5663 14.9789 19.7654 14.8626 19.9087 14.6906C20.052 14.5186 20.1305 14.3018 20.1304 14.0779V8.88018C20.1304 8.68789 20.0725 8.50006 19.9641 8.34121C19.8558 8.18235 19.702 8.05984 19.523 7.98965L14.6974 6.0986C14.4595 6.00555 14.2011 5.97769 13.9489 6.01787C13.6967 6.05806 13.4597 6.16485 13.2626 6.32721L9.75691 9.21113C9.62393 9.32 9.53327 9.47199 9.50067 9.64073C9.46806 9.80947 9.49557 9.98429 9.57841 10.1349C9.66125 10.2854 9.7942 10.4022 9.95418 10.465C10.1142 10.5278 10.2911 10.5326 10.4542 10.4785L14.3913 9.18435"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.86963 13.4887L6.35659 13.9669L9.78573 17.3961C9.89397 17.5045 10.0267 17.5853 10.1726 17.6318C10.3186 17.6782 10.4736 17.6889 10.6246 17.663L11.1029 17.5797C11.2977 17.5462 11.4773 17.4532 11.6171 17.3134C11.7568 17.1737 11.8499 16.994 11.8834 16.7992L12.0498 15.8303L13.6845 15.5481L13.9667 13.9143L15.6014 13.6322L15.8826 11.9975L13.3957 9.5105"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5888 7.70362L10.1741 6.28987C10.0403 6.15567 9.86976 6.06421 9.68397 6.02709C9.49818 5.98996 9.30556 6.00885 9.13051 6.08135L6.26094 7.27127L3.86963 7.74953"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 6.3147H2.91305C3.16673 6.3147 3.41003 6.41547 3.58941 6.59486C3.7688 6.77424 3.86957 7.01754 3.86957 7.27122V13.9669C3.86957 14.2206 3.7688 14.4639 3.58941 14.6433C3.41003 14.8226 3.16673 14.9234 2.91305 14.9234H1V6.3147Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0869 7.27124H22.9999V15.88H21.0869C20.9613 15.88 20.8369 15.8552 20.7208 15.8072C20.6048 15.7591 20.4994 15.6886 20.4105 15.5998C20.3217 15.511 20.2513 15.4055 20.2032 15.2895C20.1551 15.1734 20.1304 15.049 20.1304 14.9234V8.22776C20.1304 7.97408 20.2311 7.73078 20.4105 7.5514C20.5899 7.37202 20.8332 7.27124 21.0869 7.27124Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Relationships",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
